import { createContext, useContext } from "react";

export interface IFormContext {
  form: any | null;
  setForm: (v: any) => void;
}

export const FormContext = createContext<IFormContext>({
  form: null,
  setForm: (v: any) => null,
});

export const useResolveProp = <T = any>(
  v?: boolean | ((form: any) => boolean),
  fallback: boolean = false
) => {
  const { form, setForm } = useContext(FormContext);
  if (typeof v === "boolean") {
    return v;
  }
  if (typeof v === "function") {
    return v(form);
  }
  return fallback;
};

export const titleCase = (s: string) =>
  s
    .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
    .replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase()); // First char after each -/_

export const fieldLabel = (column: string) => titleCase(column);

